import React, { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import styled from "styled-components";
import Explain from "../../../../components/atoms/Explain";
import { StatusType } from "../../../../components/atoms/Explain/types";
import Input from "../../../../components/atoms/Input";
import TextAreas from "../../../../components/atoms/Inputs/TextAreas";
import Select from "../../../../components/atoms/Select";
import { strings } from "../../../../components/constants";
import ExplainWrapper from "../../../../components/molecures/ExplainWrapper";
import InputLines from "../../../../components/molecures/InputLines";
import Modal from "../../../../components/molecures/Modals/Modal";
import PreviewUploader from "../../../../components/molecures/PreviewUploader";
import useModals from "../../../../hooks/useModals";
import { HttpError } from "../../../../network/types";
import { Service } from "../../../../shared/enums";
import { Option } from "../../../../shared/interface";
import { alertError, alertSuccess } from "../../../../shared/utils";
import {
  getInquiryCategories,
  postInquiry,
} from "../../../../apis/Inquiry/apis";
import { PostInquiryRequest } from "../../../../apis/Inquiry/apis/types";
import { INQUIRY_KEYS } from "../../constants";

const initialStatus = { status: undefined, explain: undefined };
interface Props {
  refetchAction: any;
}
const RegisterModal: React.FC<Props> = ({ refetchAction }) => {
  const queryClient = useQueryClient();
  const postInquiryMutation = useMutation(postInquiry, {
    onSuccess: () => {
      alertSuccess(strings.SUCCESS_REGISTER);
      resetModal();
      refetchAction();
      queryClient.invalidateQueries(INQUIRY_KEYS.INQUIRIES_LIST);
    },
    onError: (err: HttpError) => alertError(err.message),
  });
  const getCategoriesMutation = useMutation(getInquiryCategories, {
    onSuccess: (res) => {
      setCategories(
        res.rows.map((val) => ({ label: val.categoryName, value: val.id }))
      );
      setDataForm({ ...dataForm, inquiryCategoryId: res.rows[0].id });
    },
    onError: (err: HttpError) => {
      if (err.status !== 404) alertError(err.message);
    },
  });
  const { resetModal, closeModal, openConfirmModal } = useModals();
  const [categories, setCategories] = useState<Option[]>([]);
  const [dataForm, setDataForm] = useState<PostInquiryRequest>({
    title: "",
    body: "",
    category: "카테고리",
    inquiryMediaIds: [],
    inquiryCategoryId: 0,
  });
  const [status, setStatus] = useState<{
    [index: string]: { status?: StatusType; explain?: string };
  }>({
    title: initialStatus,
    body: initialStatus,
    category: initialStatus,
    inquiryMediaIds: initialStatus,
  });
  const bodyKeys = Object.keys(dataForm);
  const checkNull = () => {
    const newStatus = { ...status };

    for (let i = 0; i < bodyKeys.length; i += 1) {
      if ((dataForm[bodyKeys[i]] as string).length === 0) {
        if (bodyKeys[i] !== "inquiryMediaIds")
          newStatus[bodyKeys[i]] = {
            status: "error",
            explain: "필수 항목을 입력해주세요",
          };
      }
    }
    setStatus(newStatus);
    for (let i = 0; i < bodyKeys.length; i += 1) {
      if (bodyKeys[i] !== "inquiryMediaIds")
        if ((dataForm[bodyKeys[i]] as string).length === 0) return false;
    }
    return true;
  };
  const onOk = () => {
    if (checkNull() === true)
      openConfirmModal({
        contents: "1:1문의를 등록하시겠습니까?",
        title: "1:1 문의 등록",
        onOk: () => postInquiryMutation.mutate(dataForm),
      });
  };
  const onCancel = () => {
    openConfirmModal({
      contents: (
        <div>
          1:1문의 등록 화면을 나가시겠습니까?
          <br /> 작성 내용이 저장되지 않습니다.
        </div>
      ),
      title: "1:1문의 등록 취소",
      onOk: () => resetModal(),
      onCancel: () => closeModal(),
    });
  };
  useEffect(() => {
    getCategoriesMutation.mutate({
      service: Service.REPAIR_SHOP_WEB,
      isUsedEvery: false,
      viewable: true,
    });
  }, []);
  return (
    <Modal
      title="1:1문의하기"
      onOk={onOk}
      onAdditional={onCancel}
      onCancel={onCancel}
      width={700}
    >
      <RegisterModalContainer>
        <InputLines isFill title="문의유형" alignStart>
          <ExplainWrapper status={status.category}>
            <Select
              value={
                dataForm.inquiryCategoryId === 0
                  ? categories[0]?.value
                  : dataForm.inquiryCategoryId
              }
              options={categories}
              onChange={(e) => {
                setStatus({ ...status, category: initialStatus });
                setDataForm({ ...dataForm, inquiryCategoryId: e });
              }}
              placeholder="선택"
            />
          </ExplainWrapper>
        </InputLines>

        <InputLines isFill title="제목" alignStart>
          <ExplainWrapper status={status.title}>
            <Input
              value={dataForm.title}
              onChange={(e) => {
                setStatus({ ...status, title: initialStatus });
                setDataForm({ ...dataForm, title: e.target.value });
              }}
              placeholder="제목"
            />
          </ExplainWrapper>
        </InputLines>
        <InputLines alignStart isFill title="내용">
          <TextAreas
            value={dataForm.body}
            height={200}
            onChange={(e) => {
              setStatus({ ...status, body: initialStatus });
              setDataForm({ ...dataForm, body: e });
            }}
            placeholder="내용"
          />
          {status?.body?.explain && (
            <Explain
              status={status.body.status}
              explain={status.body.explain}
            />
          )}
        </InputLines>
        <InputLines alignStart isFill title="사진" margin="0px" isOptional>
          <PreviewUploader
            folder="repairshop_inquiry/"
            onUpload={(e) => {
              setStatus({ ...status, inquiryMediaIds: initialStatus });
              setDataForm({
                ...dataForm,
                inquiryMediaIds: e.map((val) => val.id || -1),
              });
            }}
            multiple
            max={5}
            onRemove={(e) => {
              setStatus({ ...status, inquiryMediaIds: initialStatus });
              setDataForm({
                ...dataForm,
                inquiryMediaIds: e.map((val) => val.id || -1),
              });
            }}
          />
          {status?.inquiryMediaIds.explain && (
            <Explain
              status={status.inquiryMediaIds.status}
              explain={status.inquiryMediaIds.explain}
            />
          )}
        </InputLines>
      </RegisterModalContainer>
    </Modal>
  );
};
export default RegisterModal;

const RegisterModalContainer = styled.div`
  width: 700px;
  padding: 24px 24px;
`;
